import React, { useCallback, useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { useConversationService } from "../Context/ConversationsContext";

import moment from "moment";
import { useAuthService } from "../Context/AuthContext";

import WebSocketObserver from "../Helpers/websocket/WebSocketObserver";
import { useWebSocketDataService } from "../Context/WebsocketContext";
import {
  findTranslatedTextForUser,
  handleConvertBitesToMb,
  handleReceivedMessages,
  sortNewestConversations,
  sortReceivedMessages,
} from "../Helpers/chatHelper/ChatHelper";
import { mapEmoji } from "../Constants/emojiList";
import FullscreenImage from "../Components/Chat/FullscreenImage";
import RightClickMenu from "../Components/Chat/RightClickMenu";
import { useContextMenu } from "react-contexify";
import ChatDetailsHeader from "../Components/Chat/ChatDetailsHeader";
import LocalStorage from "../Helpers/LocalStorage";
import { isMobile } from "react-device-detect";
import { useNavigate } from "react-router";
import { useTranslate, useTolgee } from '@tolgee/react';
import ForwardModal from "../Components/Chat/ForwardModal";
import { cloneDeep, last } from "lodash";
import copy from "copy-to-clipboard";
import SendMedia from "../Components/Chat/SendMedia";
import SendFile from "../Components/Chat/SendFile";
import QcModal from "../Components/QuickChat/QcModal";
import QcChatDetailsView from "../Components/QuickChat/QcChatDetailsVie";
import { useCallsService } from "../Context/CallsContext";
import {
  ACCESS_LEVEL_PLATFORM,
  CHATS,
  NEUTRAL_MOOD,
  TOOLS,
  TOOLS_PRESENTATIONS,
  TOOLS_VIDEO_TRANSLATION,
  CALLS,
  PROFILE,
  SETTINGS,
  CONTACTS,
  MEETINGS,
  CONFERENCES,
  CONFERENCE_ROLE_ORGANIZER,
  CONFERENCE_ROLE_PRESENTER,
  CONFERENCE_ROLE_ATTENDEE,
  ERROR_MEETING_ROOM_DELETE_BLOCKED,
} from "../Constants/constantValues";

import BlockUsers from "../Components/ProfileComponents/BlockUsers";
import messagingPermissions from "../Helpers/RequestMessagingPermision";
import { isSimpleAndBlockedConversation } from "../Helpers/chatHelper/ConversationHelper";
import RequestNotificationsModal from "../Components/GenericComponents/RequestNotificationsModal";
import { useCookies } from "react-cookie";
import SubscriptionModal from "../Components/ProfileComponents/SubscriptionModal";
import { useSearchParams } from "react-router-dom";

import MessageDetailsModal from "../Components/Chat/MessageDetailsModal";
import RefferalModal from "../Components/Referral/RefferalModal";
import ToolsMenu from "../Components/Tools/ToolsMenu";
import LinksquaredMessageModal from "../Components/LinksquaredMessages/LinksquaredMessageModal";
import DisplayFullScreenMessage from "../Components/LinksquaredMessages/DisplayFullScreenMessage";
import { useLinksquaredService } from "../Context/LinksquaredContext";
import { Howl } from "howler";
import incomingCallRing from "../Assets/sounds/emotii-ringtone.mp3";
import { ACCESS_LEVEL } from "../Helpers/subscriptions/SubscriptionsHelper";

import { useMeetingsService } from "../Context/MeetingContext";
import { checkMicrophonePermission } from "../Helpers/RequestMichrophonePermission";
import { useGenericComponentsStateService } from "../Context/GenericComponentsStateContext";
import SideBar from "../Components/SideBar/SideBar";
import SettingsMenu from "../Components/Settings/SettingsMenu";
import ChatWrapper from "../Components/Chat/ChatWrapper";
import CallWrapper from "../Components/AudioVideoCalls/CallWrapper";
import Contacts from "../Components/Contacts/Contacts";
import Meetings from "../Components/Meetings/Meetings";
import Conferences from "../Components/Conferences/Conferences";
import { useNotify } from "../Helpers/Notifications";
import { getApiErrorMessage } from "../Helpers/apiErrorMessage";
import {
  openCall,
  canOpenCall,
  closeAllSecondaryWindows,
} from "../Helpers/navigationHelper";
import useDraftMessages from "../hooks/useDraftMessage";
import DeleteConfirmationChild from "../Components/GenericComponents/DeleteConfirmationChild";
import { joinConferenceCallApiCall } from "../API/conferences/conferencesService";
import { useConferencesService } from "../Context/ConferenceContext";
import RatingModal from "../Components/GenericComponents/RatingModal";

export const incomingCallSound = new Howl({
  src: [incomingCallRing],
  loop: true,
});

const ChatPage = ({ isMeetingOverlayActive }) => {
  const {
    setLoading,
    loading,
    setCallListSpinner,
    setMessagesListSpinner,
    setMeetingListSpinner,
    showMessageDetailsModal,
    setShowMessageDetailModal,
    showGroupChatDetails,
    setShowGroupChatDetails,
    showQuickChatDetails,
    setShowQuickChatDetails,
    isMeetingDetailsOpen,
    setIsMeetingDetailsOpen,
    isSubscriptionModalOpen,
    setIsSubscriptionModalOpen,
    isBlockUsersOpen,
    setIsBlockUsersOpen,
    isReferralMdalOpen,
    setIsReferralModalOpen,
    setIsAddNewMeetingOpen,
    isAddNewChatOpen,
    setIsAddNewChatOpen,
    isAddNewCallOpen,
    setIsAddNewCallOpen,
    isQcModalOpen,
    setIsQcModalOpen,
  } = useGenericComponentsStateService();
  const tolgee = useTolgee();

  const {
    user,
    updateUserWithNewPushToken,
    setPushToken,
    getStripePaymentLink,
    cancelStripeSubscription,
    checkSubscriptions,
    getCurrentUser,
    checkIfUserHasPermisionFor,
  } = useAuthService();

  const { add_observer, remove_observer } = useWebSocketDataService();


  const {
    getConversationsForUser,
    getMessageForConversation,
    addMessageForConversation,
    markMessageAsRead,
    editMessageForConversation,
    reactToMessageForConversation,
    removeOwnMessageReaction,
    deleteMessageForConversation,
    add_rating,
    getContacts,
    replyMessage,
    createQuickChat,
    closeQuickChat,
    blockContact,
    unblockContact,
    fetchCoversation,
    currentConversationRef,
    currentMessagesRef,
    conversationsRef,
    selectedConversation,
    setSelectedConversation,
    currentConversationMessages,
    setCurrentConversationMessages,
    conversations,
    setConversations,
    qcLinkRef,
    getConversationsForId
  } = useConversationService();
  const { t } = useTranslate();
  const {
    calls,
    getCalls,
    createGroupCall,
    selectedCall,
    setSelectedCall,
    setSelectedCallAccess,
    callsRef,
  } = useCallsService();

  const {
    getMeetings,
    meetings,
    meetingsRef,
    pastMeetings,
    pastMeetingsHasMore,
    getMeetingsHistory,
    setCurrentMeeting,
    currentMeetingRef,
    deleteMeeting,
    updateMeeting,
    regeneratePasscode,
  } = useMeetingsService();
  const {
    getConferences,
    conferences,
    conferencesRef,
    setCurrentConference,
    currentConferenceRef,
    deleteConference,
    updateConference,
  } = useConferencesService();

  const { 
    getDraftMessage, 
    saveDraftMessage, 
    clearDraftMessage, 
    hasDraftMessage,
    saveReplyState,
    clearReplyState,
    getReplyState,
    hasReplyState,
    getAllDraftConversationIds,
  } = useDraftMessages();

  const { markLinksquaredMessageAsRead, getAllReceivedData } =
    useLinksquaredService();
  const { notifySuccess, notifyError, notifyInfo } = useNotify();

  const [searchParams, setSearchParams] = useSearchParams();

  var initialInputvalues = {
    name: user.name,
    about: user.about || "",
    cultural_background: user.cultural_background,
  };

  const [cookies, setCookie] = useCookies(["notificationsModal"]);

  const messagePage = useRef(1);

  const messageInputRef = useRef();

  const shouldScrollBottom = useRef(true);

  const shouldLoadMoreMessages = useRef(true);
  const mediaInputFileRef = useRef();
  const fileInputRef = useRef();

  const [messageInput, setMessageInput] = useState("");
  const [mediaInput, setMediaInput] = useState(null);
  const [fileInput, setFileInput] = useState(null);

  const [inputValues, setInputValues] = useState(initialInputvalues);

  const [showFullScreenImg, setShowFullScreenImg] = useState(false);
  const [fullScreenImg, setFullScreenImg] = useState(null);

  const [isContactInvited, setIsContactInvited] = useState(false);
  const [selectedMessageForContextMenu, setSelectedMessageForContextMenu] =
    useState();
  const scrollHeightRef = useRef(0);

  const [showRatingCard, setShowRatingCard] = useState(false);
  const [showEditMessageModal, setShowEditMessageModal] = useState(false);
  const [showReplyMessageModal, setShowReplyMessageModal] = useState(false);

  const [toggle, setToggle] = useState(CHATS);
  const [initialToolCategory, setInitialToolCategory] = useState(null);

  const [contacts, setContacts] = useState([]);

  const [showForwardModal, setShowForwardModal] = useState(false);
  const [showBlockedChatModal, setShowBlockedChatModal] = useState(false);
  const [showRequestNotificationModal, setShowRequestNotificationModal] =
    useState(false);

  const [messageMood, setMessageMood] = useState(NEUTRAL_MOOD);
  const [isCallInProgress, setIsCallInProgress] = useState(false);

  const isElectron = !!window.electron;

  const [isLinksquaredMessageModalOpen, setIsLinksquaredMessageModalOpen] =
    useState(false);

  const [isFullScreenMessageDisplay, setIsFullScreenMessageDisplay] =
    useState(false);

  const fullScreenMessageRef = useRef();

  const [translationHistory, setTranslationHistory] = useState([]);

  const [fromLanguage, setFromLanguage] = useState(user.language);
  const [toLanguage, setToLanguage] = useState(user.language);
  const [from, setFrom] = useState("");

  const [selectedMeeting, setSelectedMeeting] = useState(false);
  const [selectedConference, setSelectedConference] = useState(null);

  const [showEditCancelConfirmation, setShowEditCancelConfirmation] = useState(false);
  const [pendingConversation, setPendingConversation] = useState(null);

  const { generateLink } = useLinksquaredService();

  const updateMessagesQueue = [];
  let isUpdateMessageProcessing = false;

  const navigate = useNavigate();
  const MENU_ID = "menu-id";

  const { show } = useContextMenu({
    id: MENU_ID,
  });

  const inviteLinkRef = useRef();

  function displayRightClickMenu(e, messageId, conversationId, messageObject) {
    const selectedText = window.getSelection().toString().trim();

    if (selectedText) {
      if (isElectron && window.electron && window.electron.showCopyMenu) {
        window.electron.showCopyMenu(selectedText, e.clientX, e.clientY);
      }
      console.log(selectedText);
      return;
    }

    if (showEditMessageModal) {
      handleCloseEdit(); 
    }

    if (showReplyMessageModal) {
      handleCloseReplyMessageOption();
    }

    setShowEditMessageModal(false);
    setShowForwardModal(false);
    setShowReplyMessageModal(false);
    setShowMessageDetailModal(false);

    setSelectedMessageForContextMenu({
      messageId: messageId,
      conversationId: conversationId,
      messageObject: messageObject,
    });

    // put whatever custom logic you need
    // you can even decide to not display the Menu
    show({
      event: e,
    });
  }

  const checkIfShouldScroll = () => {
    let element = document.getElementById("messagesList");
    if (!element) {
      return;
    }
    let scrollTop = element.scrollTop;

    if (parseFloat(scrollTop) > -200) {
      return true;
    } else {
      return false;
    }
  };

  const MessagesChannelObserver = new WebSocketObserver(
    "MessagesChannel",
    (message) => {
      const response = JSON.parse(message);

      if (response) {
        if (response.conversation_id === currentConversationRef?.current?.id) {
          shouldScrollBottom.current = checkIfShouldScroll();
          if (response.reactions.length > 0) {
            shouldScrollBottom.current = false;
          }
          const newMessages = handleReceivedMessages(
            currentMessagesRef.current,
            response
          );
          const sorted = sortReceivedMessages(newMessages);
          currentMessagesRef.current = sorted;
          setCurrentConversationMessages(sorted);
        }
      }
    }
  );

  const ConversationsChannelObserver = new WebSocketObserver(
    "ConversationsChannel",
    (message) => {
      let existingConversation = conversationsRef.current.find(
        (conv) => conv.id === message.id
      );
      if (existingConversation) {
        enqueueUpdate(() =>
          handleConversationInfoChanged(
            existingConversation.id,
            "last_message",
            message.last_message
          )
        );

        enqueueUpdate(() =>
          handleConversationInfoChanged(
            existingConversation.id,
            "unread_messages_ids",
            message.unread_messages_ids
          )
        );
 
        ['call_info', 'display_name', 'other_participants'].forEach(field => {
          if (message[field]) {
            enqueueUpdate(() =>
              handleConversationInfoChanged(
                existingConversation.id,
                field,
                message[field]
              )
            );
          }
        });
      } else {
        enqueueUpdate(() => loadConversations());
      }
    }
  );

  const ElectronNotificationsChannelObserver = new WebSocketObserver(
    "NotificationsChannel",
    (message) => {
      handleNotificationsWsResponse(message);
    }
  );

  const handleNotificationsWsResponse = (message) => {
    if (
      window.electron &&
      typeof window.electron.showElectronNotification === "function"
    ) {
      window.electron.showElectronNotification(message);
    } else {
      console.error("Electron API is not available or function not defined");
    }
  };

  const handleMessageInputChange = (e) => {
    const { value } = e.currentTarget;
    setMessageInput(value);
    
    if (selectedConversation && selectedConversation.id) {
    if (showReplyMessageModal && selectedMessageForContextMenu) {
      saveReplyState(
        selectedConversation.id,
        selectedMessageForContextMenu.messageId,
        selectedMessageForContextMenu.messageObject,
        value
      );
    } else if (!showEditMessageModal) {
      const trimmedValue = value.trim();
      if (trimmedValue.length === 0) {
        clearDraftMessage(selectedConversation.id);
      } else {
        saveDraftMessage(selectedConversation.id, trimmedValue);
      }
    }
  }
  };

  const loadConversations = async (onSuccess) => {
    const withSpinner =
      !conversationsRef.current || conversationsRef.current.length === 0;

    if (withSpinner) {
      setLoading(true);
      setMessagesListSpinner(true);
    }

    getConversationsForUser(
      async function (response) {
        let conversations = response.data.conversations;
        const draftConversationIds = getAllDraftConversationIds();
        const backendConversationIds = conversations.map(c => c.id);

        const missingDraftIds = draftConversationIds.filter(
          id => !backendConversationIds.includes(id)
        );

        let additionalConversations = [];
        let additionalConversationIds = [];
        if (conversationsRef.current && Array.isArray(conversationsRef.current)) {
          const allKnownIds = [...backendConversationIds, ...missingDraftIds];
          additionalConversations = conversationsRef.current.filter(
            c => !allKnownIds.includes(c.id)
          );
          additionalConversationIds = additionalConversations.map(c => c.id);
        }
        
        const missingConversations = [];
          for (const id of missingDraftIds) {
            try {
              const response = await new Promise((resolve, reject) => {
                getConversationsForId(
                  id,
                  (res) => resolve(res.data.conversation),
                  (err) => reject(err)
                );
              });
              if (response) {
                missingConversations.push(response);
              }
            } catch (error) {
              console.warn(`Failed to fetch conversation ${id}:`, error);
            }
        }

        const allConversations = [
          ...conversations,
          ...missingConversations,
          ...additionalConversations
        ];
        let sortedConversation = sortNewestConversations(allConversations, missingDraftIds, additionalConversationIds);
        conversationsRef.current = sortedConversation;
        setConversations(sortedConversation);
        onSuccess && onSuccess(response);
        setLoading(false);
        setMessagesListSpinner(false);
      },
      function (error) {
        setLoading(false);
        setMessagesListSpinner(false);
        console.log(error);
        notifyError(`${t('general.something_wrong')}`);
      }
    );
  };

  const loadMessageForConversation = (conversation, page) => {
    getMessageForConversation(
      conversation.id,
      page,
      function (response) {
        let responseMessages = response.data.messages;
        shouldLoadMoreMessages.current = !(response.data.messages.length < 25);
        let filteredMessages;
        if (page !== 1) {
          shouldScrollBottom.current = false;
          filteredMessages = handleReceivedMessages(
            currentConversationMessages,
            responseMessages
          );
        } else {
          filteredMessages = handleReceivedMessages([], responseMessages);
        }
        const sortedMessages = sortReceivedMessages(filteredMessages);
        currentMessagesRef.current = sortedMessages;
        setCurrentConversationMessages(sortedMessages);
        
        const conversationExists = conversationsRef.current.find(c => c.id === conversation.id);
      
        if (!conversationExists) {
          const updated = [conversation, ...conversationsRef.current];
          const sorted = sortNewestConversations(updated, [], [conversation.id]);
          conversationsRef.current = sorted;

          setConversations(sorted);
        }
      },
      function (error) {
        console.log(error, "error getMessageForConversation");
      }
    );
  };

  const initializeConversationMood = (messages) => {
    let currentUsermessages = messages.filter(
      (message) => message.user_id === user.id
    );
    let lastMessageMood = last(currentUsermessages)?.mood;

    if (lastMessageMood) {
      setMessageMood(lastMessageMood);
    } else {
      setMessageMood(NEUTRAL_MOOD);
    }
  };

  const handleStorageRatingCounter = () => {
    let currentCounter = LocalStorage.getRatingCounter();
    if (!currentCounter) {
      LocalStorage.setRatingCounter(1);
    } else {
      LocalStorage.setRatingCounter(parseInt(currentCounter) + 1);
    }
  };

  const handleSelectConversation = (conversation, skipEditCheck = false) => {

    if (selectedConversation && selectedConversation.id) {
      const hasDraft = hasDraftMessage(selectedConversation.id);
      const hasReply = hasReplyState(selectedConversation.id);
      const hasMessages = currentConversationMessages && currentConversationMessages.length > 0;
      
      const isSimpleChat = !selectedConversation.group && !selectedConversation.quick_chat;
  
      if (!hasDraft && !hasReply && !hasMessages && isSimpleChat) {
        const filtered = conversationsRef.current.filter(c => c.id !== selectedConversation.id);
        conversationsRef.current = filtered;
        setConversations(filtered);
      }
    }

    if (!skipEditCheck && showEditMessageModal && selectedMessageForContextMenu) {
      const originalText = selectedMessageForContextMenu.messageObject.original_message;
      const currentText = messageInput.trim();
      
      if (currentText !== originalText && currentText.length > 0) {
        setPendingConversation(conversation);
        setShowEditCancelConfirmation(true);
        return;
      }
    }

    if (selectedConversation && selectedConversation.id && messageInput.trim() && !showReplyMessageModal && !showEditMessageModal) {
      saveDraftMessage(selectedConversation.id, messageInput);
    }
    
    shouldScrollBottom.current = true;
    messagePage.current = 1;
    currentConversationRef.current = conversation;
    setSelectedConversation(conversation);

    if (isAddNewChatOpen) {
      setIsAddNewChatOpen(false);
    }
    if (isContactInvited) {
      setIsContactInvited(false);
    }
    if (mediaInput) {
      setMediaInput(null);
      mediaInputFileRef.current.value = null;
    }
    if (fileInput) {
      setFileInput(null);
      fileInputRef.current.value = null;
    }
    if (showEditMessageModal) {
      setShowEditMessageModal(false);
    }
    if (isMeetingDetailsOpen) {
      setIsMeetingDetailsOpen(false);
    }

    if (conversation && isSimpleAndBlockedConversation(conversation)) {
      setShowBlockedChatModal(true);
    } else {
      setShowBlockedChatModal(false);
    }

    setShowGroupChatDetails(false);
    setShowQuickChatDetails(false);
    setShowMessageDetailModal(false);

    if (conversation && conversation.id) {
      const replyState = getReplyState(conversation.id);
      if (replyState) {
        setShowReplyMessageModal(true);
        setSelectedMessageForContextMenu({
          messageId: replyState.messageId,
          conversationId: conversation.id,
          messageObject: replyState.messageObject,
        });
        setMessageInput(replyState.replyText || "");
      } else {
        setShowReplyMessageModal(false);
        setSelectedMessageForContextMenu(null);
        const draftMessage = getDraftMessage(conversation.id);
        setMessageInput(draftMessage || "");
      }
    } else {
      setShowReplyMessageModal(false);
      setSelectedMessageForContextMenu(null);
      setMessageInput("");
    }

    // setMessageInput("");
    setSelectedCall(null);
    setSelectedCallAccess(null);
    // loadConversations();
    if (!conversation) {
      loadConversations();
    }
  };

  const handleSelectCall = async (call, video = null) => {
    if (isCallInProgress) return; // Prevent multiple calls
    setIsCallInProgress(true);

    setTimeout(() => setIsCallInProgress(false), 2000); // Reset after 2000ms

    if (call.close_date === null) {
      checkMicrophonePermission().then((permission) => {
        if (permission === "granted") {
          connectToOngoingCall(call);
        } else if (permission === "denied") {
          notifyError(t('call_modal.enable_calling_message'));
        }
      });
    } else {
      checkSubscriptionAndExecute(ACCESS_LEVEL.PREMIUM, () => {
        checkMicrophonePermission().then((permission) => {
          if (permission === "granted") {
            if (call.is_call_chat) {
              makeGroupCall(call, video);
            } else if (call.group && call.other_participants.length > 1) {
              makeGroupCall(call, video);
            } else {
              makeSimpleCall(call, video);
            }
          } else if (permission === "denied") {
            notifyError(t('call_modal.enable_calling_message'));
          }
        });
      });
    }
  };

  const handleJoinMeeting = (meeting) => {
    if (isMeetingDetailsOpen) {
      setIsMeetingDetailsOpen(false);
    }

    checkMicrophonePermission().then((permission) => {
      if (permission === "granted") {
        currentMeetingRef.current = meeting;
        setCurrentMeeting(meeting);
        connectToOngoingCall(meeting.call, meeting.id);
      } else if (permission === "denied") {
        notifyError(t('call_modal.enable_calling_message'));
      }
    });
  };

  const isAttendeeRole = (role) => role === CONFERENCE_ROLE_ATTENDEE;

  const getConferenceRoleForCurrentUser = (conference) => {
    if (!conference || !user) return CONFERENCE_ROLE_ATTENDEE;
    const organizers = conference.organizers || [];
    const participantEntries = conference.participants || [];
    const userId = String(user.id);

    if (organizers.some((org) => String(org.id) === userId)) {
      return CONFERENCE_ROLE_ORGANIZER;
    }

    const roleEntry = participantEntries.find(
      (participant) => participant.user && String(participant.user.id) === userId
    );

    if (roleEntry?.role === CONFERENCE_ROLE_PRESENTER) {
      return CONFERENCE_ROLE_PRESENTER;
    }

    if (roleEntry && isAttendeeRole(roleEntry.role)) {
      return CONFERENCE_ROLE_ATTENDEE;
    }

    return CONFERENCE_ROLE_ATTENDEE;
  };

  const persistConferenceMediaPermissions = (conference, call) => {
    if (!conference) return;
    const settings = conference.settings || {};
    const role = getConferenceRoleForCurrentUser(conference);
    const isAttendee = isAttendeeRole(role);
    // Organizers/presenters keep control; attendees are listen-only.
    const micAllowed = isAttendee ? false : true;
    const cameraAllowed = isAttendee ? settings.allow_camera !== false : true;
    const chatAllowed = settings.allow_chat !== false;
    const pollsAllowed = settings.allow_polls !== false;

    LocalStorage.setConferenceMediaPermissions({
      callUuid: call.uuid,
      conferenceId: conference.id,
      role,
      micAllowed,
      cameraAllowed,
      chatAllowed,
      pollsAllowed,
      storedAt: new Date().toISOString(),
    });
  };

  const handleJoinConference = (conference) => {
    if (isMeetingDetailsOpen) {
      setIsMeetingDetailsOpen(false);
    }

    const role = getConferenceRoleForCurrentUser(conference);
    const skipMicPermissionCheck = isAttendeeRole(role);

    const proceedJoinConference = () => {
      joinConferenceCallApiCall(
        conference.id,
        (response) => {
          const call =
            response?.data?.call ||
            response?.data?.conference_call ||
            conference.call;
          currentConferenceRef.current = { ...conference, call };
          setCurrentConference({ ...conference, call });
          setLoading(false);
          if (!call) {
            notifyError(t('general.something_wrong'));
            return;
          }
          persistConferenceMediaPermissions(conference, call);
          connectToOngoingCall(call, conference.id, true);
        },
        () => {
          setLoading(false);
          notifyError(t('general.something_wrong'));
        }
      );
    };

    setLoading(true);
    if (skipMicPermissionCheck) {
      proceedJoinConference();
      return;
    }

    checkMicrophonePermission().then((permission) => {
      if (permission === "granted") {
        proceedJoinConference();
      } else if (permission === "denied") {
        setLoading(false);
        notifyError(t('call_modal.enable_calling_message'));
      }
    });
  };

  const makeSimpleCall = (call, video = null) => {
    let otherParticipant = call.other_participants[0];
    let otherParticipantId = [otherParticipant.id];
    let videoCall = false;
    if (video === true) {
      videoCall = true;
    }

    if (!otherParticipant.blocked) {
      handleSelectConversation(null);
      handleCreateGroupCall(otherParticipantId, null, videoCall);
    } else {
      notifyError(t('block_contacts.this_contact_is_blocked'));
    }
  };

  const makeGroupCall = async (call, video = null) => {
    let groupId = call.group?.id || null;
    let usersId = [];
    if (call.is_call_chat) {
      usersId = call.other_participants.map((participant) => participant.id);
      
      if (call.created_by && call.created_by.id !== user.id && !usersId.includes(call.created_by.id)) {
        usersId.push(call.created_by.id);
      }
    } else {
      usersId = call.other_participants.map((participant) => participant.id);
    }


    let videoCall = false;
    if (video === true) {
      videoCall = true;
    }

    let numberOfUsers = usersId.length;
    if (call.is_call_chat && numberOfUsers < 1) {
      return;
    }
    if (!call.is_call_chat && numberOfUsers <= 1) {
      return
    }

    let accessLevel = ACCESS_LEVEL.PREMIUM;

    if (numberOfUsers > 5) {
      accessLevel = ACCESS_LEVEL_PLATFORM;
    }

    checkSubscriptionAndExecute(accessLevel, () => {
      handleSelectConversation(null);
      handleCreateGroupCall(usersId, groupId, videoCall);
    });
  };

  const connectToOngoingCall = async (call, referenceId = null, isConference = false) => {
    handleSelectConversation(null);
    if (isMeetingDetailsOpen) {
      setIsMeetingDetailsOpen(false);
      setSelectedMeeting(null);
      setSelectedConference(null);
    }
    if (isAddNewCallOpen) {
      setIsAddNewCallOpen(false);
    }

    var openedCall = await openCall(
      navigate,
      call.uuid,
      isConference ? null : (referenceId || currentMeetingRef.current?.id),
      false,
      isConference ? (referenceId || currentConferenceRef.current?.id) : null
    );

    if (!openedCall) {
      notifyError(t('call_modal.another_call_in_progress'));
    }
  };

  const handleSendMedia = (type, file, text, thumbnail) => {
    setLoading(true);
    let dataObject = new FormData();
    let nowDate = moment().toISOString();

    dataObject.append("device_sent_date", nowDate);
    dataObject.append("original_message", "");
    dataObject.append("mood", messageMood);

    if (type === "image") {
      dataObject.append("image", file);
    }

    if (type === "video") {
      dataObject.append("video", file);
      dataObject.append("video_thumbnail", thumbnail);
    }

    if (text.length > 0) {
      dataObject.append("original_message", text);
    }

    addMessageForConversation(
      dataObject,
      selectedConversation.id,
      function (response) {
        const sortedMessages = sortReceivedMessages(
          handleReceivedMessages(
            currentMessagesRef.current,
            response.data.message
          )
        );
        currentMessagesRef.current = sortedMessages;
        setCurrentConversationMessages(sortedMessages);
        mediaInputFileRef.current.value = "";
        fileInputRef.current.value = "";
        setMessageInput("");
        if (selectedConversation && selectedConversation.id) {
          clearDraftMessage(selectedConversation.id);
        }
        shouldScrollBottom.current = true;
        setLoading(false);
      },
      function (error) {
        mediaInputFileRef.current.value = "";
        fileInputRef.current.value = "";
        console.log(error, "error");
        setLoading(false);
        if (error.response.status === 413) {
          notifyError(
            `${t('chat.file_size_exceded')
            } ${handleConvertBitesToMb(error.response.data.max_size)}MB`
          );
        } else {
          notifyError(t('general.something_wrong'));
        }
      }
    );
  };

  const handleSendFile = (file, text) => {
    setLoading(true);
    let dataObject = new FormData();
    let nowDate = moment().toISOString();

    dataObject.append("device_sent_date", nowDate);
    dataObject.append("original_message", "");
    dataObject.append("document", file);
    dataObject.append("mood", messageMood);

    if (text.length > 0) {
      dataObject.append("original_message", text);
    }

    addMessageForConversation(
      dataObject,
      selectedConversation.id,
      function (response) {
        const sortedMessages = sortReceivedMessages(
          handleReceivedMessages(
            currentMessagesRef.current,
            response.data.message
          )
        );
        currentMessagesRef.current = sortedMessages;
        setCurrentConversationMessages(sortedMessages);

        mediaInputFileRef.current.value = "";
        fileInputRef.current.value = "";
        setMessageInput("");
        if (selectedConversation && selectedConversation.id) {
          clearDraftMessage(selectedConversation.id);
        }

        shouldScrollBottom.current = true;

        setLoading(false);
      },
      function (error) {
        mediaInputFileRef.current.value = "";
        fileInputRef.current.value = "";
        console.log(error, "error");
        setLoading(false);
        if (error.response.status === 413) {
          notifyError(
            `${t('chat.file_size_exceded')
            } ${handleConvertBitesToMb(error.response.data.max_size)}MB`
          );
        } else {
          notifyError(t('general.something_wrong'));
        }
        if (error.response.status === 413) {
          notifyError(
            `${t('chat.file_size_exceded')
            } ${handleConvertBitesToMb(error.response.data.max_size)}MB`
          );
        } else {
          notifyError(t('general.something_wrong'));
        }
      }
    );
  };

  const handleSendMessage = () => {
    if (!messageInput.replace(/\s/g, "").length) {
      return Promise.resolve(); // Still return a promise so you can await it
    }
    return new Promise((resolve, reject) => {
      let nowDate = moment().toISOString();
      let dataObject = new FormData();
      dataObject.append("device_sent_date", nowDate);
      dataObject.append("original_message", messageInput);
      dataObject.append("mood", messageMood);

      addMessageForConversation(
        dataObject,
        selectedConversation.id,
        function (response) {
          const newMessages = handleReceivedMessages(
            currentMessagesRef.current,
            response.data.message
          );
          const sorted = sortReceivedMessages(newMessages);
          currentMessagesRef.current = sorted;
          setCurrentConversationMessages(sorted);
          setMessageInput("");
          clearDraftMessage(selectedConversation.id);
          shouldScrollBottom.current = true;
          handleStorageRatingCounter();
          resolve(); // ✅ done
        },
        function (error) {
          console.log(error, "error");
          reject(error); // ❌ failed
        }
      );
    });
  };

  const handleReplyMessage = () => {
    if (!messageInput.replace(/\s/g, "").length) {
      return;
    }

    let nowDate = moment().toISOString();
    let dataObject = new FormData();
    dataObject.append("device_sent_date", nowDate);
    dataObject.append("original_message", messageInput);
    dataObject.append("mood", messageMood);

    replyMessage(
      dataObject,
      selectedMessageForContextMenu.conversationId,
      selectedMessageForContextMenu.messageId,
      (response) => {
        const newMessages = handleReceivedMessages(
          currentMessagesRef.current,
          response.data.message
        );
        const sorted = sortReceivedMessages(newMessages);
        currentMessagesRef.current = sorted;
        setCurrentConversationMessages(sorted);
        setMessageInput("");
        shouldScrollBottom.current = true;
        handleStorageRatingCounter();
        handleCloseReplyMessageOption();
      },
      (error) => {
        notifyError(t('general.something_wrong'));
      }
    );
  };

  const handleReplyWithMedia = (type, file, text, thumbnail) => {
    setLoading(true);
    let dataObject = new FormData();
    let nowDate = moment().toISOString();

    dataObject.append("device_sent_date", nowDate);
    dataObject.append("original_message", "");
    dataObject.append("mood", messageMood);

    if (text.length > 0) {
      dataObject.append("original_message", text);
    }
    if (type === "image") {
      dataObject.append("image", file);
    }

    if (type === "video") {
      dataObject.append("video", file);
      dataObject.append("video_thumbnail", thumbnail);
    }

    replyMessage(
      dataObject,
      selectedMessageForContextMenu.conversationId,
      selectedMessageForContextMenu.messageId,
      function (response) {
        const sortedMessages = sortReceivedMessages(
          handleReceivedMessages(
            currentMessagesRef.current,
            response.data.message
          )
        );
        currentMessagesRef.current = sortedMessages;
        setCurrentConversationMessages(sortedMessages);
        mediaInputFileRef.current.value = "";
        fileInputRef.current.value = "";
        setLoading(false);
        setMessageInput("");
        shouldScrollBottom.current = true;
        handleCloseReplyMessageOption();
      },
      function (error) {
        mediaInputFileRef.current.value = "";
        fileInputRef.current.value = "";
        console.log(error, "error");
        setLoading(false);
        if (error.response.status === 413) {
          notifyError(
            `${t('chat.file_size_exceded')
            } ${handleConvertBitesToMb(error.response.data.max_size)}MB`
          );
        } else {
          notifyError(t('general.something_wrong'));
        }
        if (error.response.status === 413) {
          notifyError(
            `${t('chat.file_size_exceded')
            } ${handleConvertBitesToMb(error.response.data.max_size)}MB`
          );
        } else {
          notifyError(t('general.something_wrong'));
        }
      }
    );
  };

  const handleReplyWithFile = (file, text) => {
    setLoading(true);
    let dataObject = new FormData();
    let nowDate = moment().toISOString();

    dataObject.append("device_sent_date", nowDate);
    dataObject.append("original_message", "");
    dataObject.append("document", file);
    dataObject.append("mood", messageMood);

    replyMessage(
      dataObject,
      selectedMessageForContextMenu.conversationId,
      selectedMessageForContextMenu.messageId,
      function (response) {
        const sortedMessages = sortReceivedMessages(
          handleReceivedMessages(
            currentMessagesRef.current,
            response.data.message
          )
        );
        currentMessagesRef.current = sortedMessages;
        setCurrentConversationMessages(sortedMessages);
        mediaInputFileRef.current.value = "";
        fileInputRef.current.value = "";
        setLoading(false);
        setMessageInput("");
        shouldScrollBottom.current = true;
        handleCloseReplyMessageOption();
      },
      function (error) {
        mediaInputFileRef.current.value = "";
        fileInputRef.current.value = "";
        console.log(error, "error");
        setLoading(false);
        if (error.response.status === 413) {
          notifyError(
            `${t('chat.file_size_exceded')
            } ${handleConvertBitesToMb(error.response.data.max_size)}MB`
          );
        } else {
          notifyError(t('general.something_wrong'));
        }
        if (error.response.status === 413) {
          notifyError(
            `${t('chat.file_size_exceded')
            } ${handleConvertBitesToMb(error.response.data.max_size)}MB`
          );
        } else {
          notifyError(t('general.something_wrong'));
        }
      }
    );
  };

  const handleConfirmCancelEdit = () => {
    setShowEditMessageModal(false);
    setSelectedMessageForContextMenu(null);
    
    setShowEditCancelConfirmation(false);
    
    if (pendingConversation) {
      const conv = pendingConversation;
      setPendingConversation(null);
      

      setTimeout(() => {
        handleSelectConversation(conv, true);
      }, 0);
    }
  };

  const handleEditMessage = () => {
    editMessageForConversation(
      selectedMessageForContextMenu.conversationId,
      selectedMessageForContextMenu.messageId,
      messageInput,
      (response) => {
        handleEditMessageResponse(response.data.message);
        clearDraftMessage(selectedConversation.id);
        handleCloseEdit();
      },
      (error) => {
        notifyError(t('general.something_wrong'));
      }
    );
  };

  const handleEditMessageResponse = (message) => {
    let messages = currentConversationMessages;
    messages = messages.map((item) => {
      if (item.id === message.id) {
        return message;
      } else {
        return item;
      }
    });
    setCurrentConversationMessages(messages);
  };

  const handleSendButton = async () => {
    if (showEditMessageModal) {
      handleEditMessage();
      return;
    }

    if (showReplyMessageModal) {
      handleReplyMessage();
      return;
    }

    return handleSendMessage();
  };

  const handleGetMoreMessages = () => {
    if (shouldLoadMoreMessages.current) {
      messagePage.current += 1;
      loadMessageForConversation(selectedConversation, messagePage.current);
    }
  };

  const handleConversationInfoChanged = (id, field, value) => {
    setConversations((prevData) => {
      var newData = prevData?.map((item) => {
        if (item.id === id) {
          return { ...item, [field]: value };
        }
        return item;
      });

      const draftIds = getAllDraftConversationIds();
    
      const tempIds = newData
        .filter(c => !c.group && !c.quick_chat && (!c.last_message?.id || c.last_message.created_at === c.created_at))
        .map(c => c.id);
      
      let sortedNewData = sortNewestConversations(newData, draftIds, tempIds);
      return sortedNewData;
    });
    
    if (field === 'call_info' || field === 'display_name' || field === 'other_participants') {
      setSelectedConversation(prev => {
        if (prev && prev.id === id) {
          return { ...prev, [field]: value };
        }
        return prev;
      });
    }
  };

  const setLastMessage = (currentMessages) => {
    const lastMessage = currentMessages[currentMessages.length - 1];
    handleConversationInfoChanged(
      lastMessage.conversation_id,
      "last_message",
      lastMessage
    );
  };

  const handleReactToMessage = (reactionText, conversationId, messageId) => {
    let reaction = mapEmoji(reactionText);
    if (!reaction) {
      return;
    }
    reactToMessageForConversation(
      reaction,
      conversationId,
      messageId,
      function (response) { },
      function (error) {
        console.log(error);
      }
    );
  };

  const handleRemoveOwnMessageReaction = (reactionId, conversationId, messageId) => {
    removeOwnMessageReaction(
      conversationId,
      messageId,
      reactionId,
      function (response) { },
      function (error) {
        console.log(error);
      }
    );
  }

  const handleShowFullScreenImg = (image, messageId, conversationId) => {
    setFullScreenImg({
      image: image,
      messageId: messageId,
      conversationId: conversationId,
    });
    setShowFullScreenImg(true);
  };

  const handleCloseFullScreenImg = () => {
    setShowFullScreenImg(false);
    setFullScreenImg(null);
  };

  const handleDeleteMessage = (conversationId, messageId) => {
    deleteMessageForConversation(
      conversationId,
      messageId,
      function (response) {
        // Remove deleted message from UI immediately only if it's NOT our own message.
        if (
          currentConversationRef?.current?.id === conversationId &&
          Array.isArray(currentMessagesRef.current)
        ) {
          const deletedMsg = currentMessagesRef.current.find((m) => m.id === messageId);
          const isOwn = deletedMsg && deletedMsg.user_id === user.id;

          if (!isOwn) {
            const filteredMessages = currentMessagesRef.current.filter(
              (item) => item.id !== messageId
            );
            currentMessagesRef.current = filteredMessages;
            setCurrentConversationMessages(filteredMessages);

            // Update last_message on the conversation if needed
            const newLastMessage =
              filteredMessages.length > 0
                ? filteredMessages[filteredMessages.length - 1]
                : null;
            handleConversationInfoChanged(conversationId, "last_message", newLastMessage);
          }
          // If it's our own message, we allow the bubble to stay (e.g., empty/“deleted” state).
        }
        console.log(response);
      },
      function (error) {
        console.log(error);
        notifyError(`${t('general.something_wrong')}`);
      }
    );
  };

  const handleDeletePhoto = () => {
    handleDeleteMessage(fullScreenImg.conversationId, fullScreenImg.messageId);
    setShowFullScreenImg(false);
  };

  const handleReportMessage = () => {
    window.location = "mailto:support@emotii.ai";
  };

  const handleShowGroupChatDetails = () => {
    setShowGroupChatDetails(!showGroupChatDetails);
  };

  const handleShowConversationDetailsMenu = (selectedConversation) => {
    if (!selectedConversation) {
      return;
    }
    if (selectedConversation.quick_chat) {
      handleShowQcChatDetails();
    } else {
      handleShowGroupChatDetails();
    }

    if (showMessageDetailsModal) {
      setShowMessageDetailModal(false);
    }
  };

  const handleShowQcChatDetails = () => {
    setShowQuickChatDetails(!showQuickChatDetails);
  };

  const handleForwardMessage = () => {
    setShowForwardModal(true);
  };

  const handleSendRating = (rating) => {
    if (!selectedConversation) {
      setShowRatingCard(false);
      return;
    }
    add_rating(
      selectedConversation.id,
      rating,
      function (response) {
        notifySuccess(`${t('chat.rating_sent')}`);
        setShowRatingCard(false);
      },
      function (error) {
        notifyError(`${t('general.something_wrong')}`);
        setShowRatingCard(false);
        console.log(error);
      }
    );
  };

  const loadContacts = () => {
    getContacts(
      function (response) {
        let sortedAppContacts = response.data["on_app_contacts"].sort((a, b) =>
          a.name > b.name ? 1 : -1
        );
        let sortedOutsideAppContacts = response.data["outside_contacts"].sort(
          (a, b) => (a.name > b.name ? 1 : -1)
        );
        setContacts({
          on_app_contacts: sortedAppContacts,
          outside_contacts: sortedOutsideAppContacts,
        });
      },
      function (error) {
        console.log(error);
      }
    );
  };

  const handleStartNewChat = (contact) => {
    let phone = contact.phone_number;
    let email = contact.email;
    if (
      (phone && phone === user.phone_number) ||
      (email && email === user.email)
    ) {
      notifyError(`${t('new_chat.cant_have_conv_with_u')}`);
    } else {
      let dataObj = {};
      if (contact.phone_number) {
        dataObj.phone_number = phone;
      }
      if (contact.email) {
        dataObj.email = email;
      }
      fetchCoversation(
        dataObj,
        function (response) {
          let clone = cloneDeep(conversations);
          let found = clone.find(
            (item) => item.id === response.data.conversation.id
          );
          if (found) {
            setToggle(CHATS);
            handleSelectConversation(found);
          } else {
            setToggle(CHATS);
            handleSelectConversation(response.data.conversation);
          }
        },
        function (error) {
          console.log(error, "error");
          notifyError(`${t('general.something_wrong')}`);
        }
      );
    }
  };

  const handleInviteContact = (contact) => {
    createLink();
  };

  const createLink = (genericLink) => {
    let title = "Join emotii";
    let textMessage =
      "Check out this new app, tap the link, and let's communicate without boundaries.";

    if (!inviteLinkRef.current) {
      generateInviteLink();
      return;
    }

    copy(`${title}\n${textMessage}\n${inviteLinkRef.current} `);
    notifySuccess(t('misc.link_copied'));
  };

  const generateInviteLink = () => {
    setLoading(true);
    generateLink(
      "Join emotii",
      "You're invited to join emotii. Tap the link below and start communicating without boundaries.",
      user,
      (successData) => {
        setLoading(false);
        inviteLinkRef.current = successData;
      },
      (errorData) => {
        // setLoading(false);
        console.error("Error creating link:", errorData);
      }
    );
  };

  const handleShareQcLink = (link) => {
    copy(link);
    notifySuccess(t('misc.link_copied'));
  };

  const handleEditMessageOption = () => {
    setShowEditMessageModal(true);
    setMessageInput(
      selectedMessageForContextMenu.messageObject.original_message
    );

    if (selectedConversation) {
      clearDraftMessage(selectedConversation.id);
    }

    messageInputRef.current.focus();
  };

  const handleCloseEdit = () => {
    setShowEditMessageModal(false);
    setSelectedMessageForContextMenu(null);
    if (selectedConversation) {
      const draftMessage = getDraftMessage(selectedConversation.id);
      setMessageInput(draftMessage || "");
    } else {
      setMessageInput("");
    }
  };

  const handleReplyMessageOption = () => {

    if (!selectedMessageForContextMenu) {
      return;
    }

    const existingDraft = selectedConversation && selectedConversation.id 
      ? getDraftMessage(selectedConversation.id) 
      : "";

    const textForReply = messageInput.trim() || existingDraft

    if (selectedConversation && selectedConversation.id && existingDraft) {
      clearDraftMessage(selectedConversation.id);
    }

    setShowReplyMessageModal(true);
    setMessageInput(textForReply);
    if (selectedConversation && selectedConversation.id) {
      saveReplyState(
        selectedConversation.id,
        selectedMessageForContextMenu.messageId,
        selectedMessageForContextMenu.messageObject,
        textForReply
      );
    }
    messageInputRef.current.focus();
  };

  const handleCloseReplyMessageOption = () => {
    setShowReplyMessageModal(false);
    if (selectedConversation) {
      clearReplyState(selectedConversation.id);
      if (messageInput.trim().length > 0) {
        saveDraftMessage(selectedConversation.id, messageInput);
      } else {
        clearDraftMessage(selectedConversation.id);
      }
    } 
    setSelectedMessageForContextMenu(null);  
  };

  const handleCloseForwardModal = () => {
    setShowForwardModal(false);
  };

  const handleSendMediaButton = (type, file, text, thumbnail) => {
    if (showReplyMessageModal) {
      handleReplyWithMedia(type, file, text, thumbnail);
    } else {
      handleSendMedia(type, file, text, thumbnail);
    }
  };
  const handleSendFileButton = (file, text) => {
    if (showReplyMessageModal) {
      handleReplyWithFile(file, text);
    } else {
      handleSendFile(file, text);
    }
  };

  const handleCopyOption = (message) => {
    console.log(message);
    if (message.showOriginalMessage) {
      copy(message.original_message);
    } else {
      let translated = findTranslatedTextForUser(
        message.message_translations,
        user
      );
      copy(translated.translation);
    }

    notifySuccess(t('misc.copy'));
  };

  const handleCloseQcChat = (chatId) => {
    setLoading(true);
    closeQuickChat(
      chatId,
      (response) => {
        setLoading(false);
        loadConversations();
        setSelectedConversation(null);
      },
      (error) => {
        notifyError(t('general.something_wrong'));
        console.log(error);
        setLoading(false);
      }
    );
  };

  const handleCloseChatBtn = (chatId) => {
    handleCloseQcChat(chatId);
    setShowQuickChatDetails(false);
  };

  const loadCalls = () => {
    const withSpinner = !callsRef.current || callsRef.current.length === 0;
    if (withSpinner) {
      setCallListSpinner(true);
    }

    getCalls(
      (response) => {
        setCallListSpinner(false);
      },
      (error) => {
        console.log(error);
        setCallListSpinner(false);
      }
    );
  };

  const createCallInProgressRef = useRef(false);

  const handleCreateGroupCall = async (usersId, groupId, video) => {
    if (createCallInProgressRef.current === true) {
      notifyError(t('call_modal.another_call_in_progress'));
      return;
    }

    createCallInProgressRef.current = true;

    setLoading(true);

    if (isMeetingDetailsOpen) {
      setIsMeetingDetailsOpen(false);
      setSelectedMeeting(null);
    }

    if (isAddNewCallOpen) {
      setIsAddNewCallOpen(false);
    }

    const canOpen = await canOpenCall();
    if (!canOpen) {
      setLoading(false);
      notifyError(t('call_modal.another_call_in_progress'));
      return;
    }

    if (toggle !== CALLS) {
      setToggle(CALLS);
    }

    createGroupCall(
      usersId,
      groupId,
      video,
      async (response) => {
        var openedCall = await openCall(
          navigate,
          response.data.details.uuid,
          currentMessagesRef.current?.id
        );

        if (!openedCall) {
          notifyError(t('call_modal.another_call_in_progress'));
        }

        setLoading(false);

        createCallInProgressRef.current = false;
      },

      (error) => {
        setLoading(false);
        createCallInProgressRef.current = false;

        const errorCode = error?.response?.data?.error_code;
        const statusCode = error?.response?.status;

        if (errorCode === "ACCESS1006") {
          notifyError(t('call_modal.call_minutes_limit_reached'));
        } else if (errorCode === "ACCESS1001" || errorCode === "ACCESS1004" || errorCode === "ACCESS1005") {
          notifyError(t('misc.platform_error'));
        } else if (statusCode === 404) {
          notifyError(t('call_modal.unable_to_initiate'));
        } else {
          notifyError(t('general.something_wrong'));
          console.log(error);
        }
      }
    );
  };

  const handleCreateCallHeaderClick = (call, video) => {
    handleSelectCall(call, video);
    hideDetailsViews();
  };

  const hideDetailsViews = () => {
    showMessageDetailsModal && setShowMessageDetailModal(false);
    showGroupChatDetails && setShowGroupChatDetails(false);
    showQuickChatDetails && setShowQuickChatDetails(false);
  };

  const handleCreateCallOnContactClick = (contact, video) => {
    checkSubscriptionAndExecute(ACCESS_LEVEL.PREMIUM, () => {
      setToggle(CALLS);
      let otherParticipant = contact;
      let otherParticipantId = [contact.id];
      if (!otherParticipant.blocked) {
        handleSelectConversation(null);
        handleCreateGroupCall(otherParticipantId, null, video);
      } else {
        notifyError(t('block_contacts.this_contact_is_blocked'));
      }
    });
  };

  const checkSubscriptionAndExecute = (accessLevel, success, onFail) => {
    checkIfUserHasPermisionFor(
      accessLevel,
      () => {
        success();
      },
      () => {
        notifyError(t('misc.need_to_upgrade_subscription'));
        onFail?.();
      },
      () => {
        // Open subscription modal
        setIsSubscriptionModalOpen(true);
        onFail?.();
      }
    );
  };

  const handleCloseBlockUsers = () => {
    setIsBlockUsersOpen(false);
  };

  const handleBlockContact = (contact, callback) => {
    setLoading(true);
    blockContact(
      contact.phone_number,
      contact.name,
      contact.email,
      (response) => {
        loadConversations((resp) => {
          if (!selectedConversation) {
            return;
          }
          let found = resp.data.conversations.find(
            (item) => item.id === selectedConversation.id
          );
          setSelectedConversation(found);
        });
        callback && callback();
      },
      (error) => {
        console.log(error);
        setLoading(false);
      }
    );
  };

  const handleUnblockContact = (contact, callback) => {
    setLoading(true);
    unblockContact(
      contact.phone_number,
      contact.email,
      (response) => {
        loadConversations((resp) => {
          if (!selectedConversation) {
            return;
          }
          let found = resp.data.conversations.find(
            (item) => item.id === selectedConversation.id
          );

          setSelectedConversation(found);
          setShowBlockedChatModal(false);
        });
        callback && callback();
        // setLoading(false)
      },
      (error) => {
        console.log(error);
        setLoading(false);
      }
    );
  };

  const handleCloseRequestNotificationModal = () => {
    setShowRequestNotificationModal(false);
    setCookie("notificationsModal", "disabled");
  };

  const handleRequestNotificationsPermission = () => {
    messagingPermissions.requestPermission((response) => {
      setCookie("notificationsModal", "disabled");
      setPushToken(response);
      updateUserWithNewPushToken(response);
    });
    setShowRequestNotificationModal(false);
  };

  const fetchPushTokenIfPossible = () => {
    messagingPermissions.getCurrentNotificationTokenIfPossible((response) => {
      setPushToken(response);
      updateUserWithNewPushToken(response);
    });
  };

  const handleOpenSubscriptionModal = () => {
    setIsSubscriptionModalOpen(true);
  };

  const handleCloseSubscriptionModal = () => {
    setIsSubscriptionModalOpen(false);
  };

  const handleSubscribeBtnElectron = (type, payYearly) => {
    setLoading(true);
    if (type !== "premium") {
      return
    }
    let subscriptionType = "premium";
    if (payYearly) {
      subscriptionType += "_yearly";
    } else {
      subscriptionType += "_monthly";
    }
    getStripePaymentLink(
      subscriptionType,
      (response) => {
        const link = response.data.url;
        if (
          window.electron &&
          typeof window.electron.openSubscribeWindow === "function"
        ) {
          window.electron.openSubscribeWindow(link);
        } else {
          console.error(
            "Electron API is not availbale or function not defined"
          );
        }
        setLoading(false);
      },
      (error) => {
        setLoading(false);
        console.log(error);
        notifyError(t('general.something_wrong'));
      }
    );
  };

  const handleSubscribeBtn = (type, payYearly) => {
    setLoading(true);
    if (type !== "premium") {
      return
    }
    let subscriptionType = "premium";
    if (payYearly) {
      subscriptionType += "_yearly";
    } else {
      subscriptionType += "_monthly";
    }
    getStripePaymentLink(
      subscriptionType,
      (response) => {
        const link = response.data.url;
        window.location = link;
        getCurrentUser(
          () => { },
          () => { }
        );
        setLoading(false);
      },
      (error) => {
        setLoading(false);
        console.log(error);
        notifyError(t('general.something_wrong'));
      }
    );
  };

  const handleSubscribeClick = (type, payYearly) => {
    if (isElectron) {
      handleSubscribeBtnElectron(type, payYearly);
    } else {
      handleSubscribeBtn(type, payYearly);
    }
  };

  const handleUnSubscribeClick = () => {
    setLoading(true);
    cancelStripeSubscription(
      (response) => {
        setIsSubscriptionModalOpen(false);
        notifySuccess(t('subscription_modal.canceled'));
        setTimeout(() => {
          checkSubscriptions();
          getCurrentUser(
            () => { },
            () => { }
          );
          setLoading(false);
        }, 3000);
      },
      (error) => {
        setLoading(false);
        console.log(error);
        notifyError(t('general.something_wrong'));
      }
    );
  };

  const handleShowMessageInfoModal = () => {
    setShowMessageDetailModal(!showMessageDetailsModal);
  };

  const handleOpenMessageInfoModal = () => {
    setShowGroupChatDetails(false);
    setShowQuickChatDetails(false);
    setShowMessageDetailModal(true);
  };

  const handleLinksquaredDeepLink = () => {
    getAllReceivedData((dataArray) => {
      if (!dataArray) {
        return;
      }

      dataArray.forEach((dict) => {
        if (dict["deeplink_path"] === "subscription") {
          setIsSubscriptionModalOpen(true);
        }
      });
    });
  };

  const handleResponseFromStripe = (response) => {
    if (response.from_stripe || response.cancel_from_stripe) {
      checkSubscriptions();
      getCurrentUser(
        () => { },
        () => { }
      );
    }
  };

  const handleCloseReferralModal = () => {
    setIsReferralModalOpen(false);
  };

  const handleSetInvitationsSubscribeModal = () => {
    setIsSubscriptionModalOpen(false);
    setIsReferralModalOpen(true);
  };

  const handleOpenLinksuaredMessages = () => {
    setIsLinksquaredMessageModalOpen(true);
  };

  const handleCloseLinksuaredMessages = () => {
    setIsLinksquaredMessageModalOpen(false);
  };

  const handleLinksquaredMessageClick = (message) => {
    setIsFullScreenMessageDisplay(true);
    markLinksquaredMessageAsRead(message);
    fullScreenMessageRef.current = message;
  };

  const handleCloseFullScreenMessageDisplay = () => {
    setIsFullScreenMessageDisplay(false);
    fullScreenMessageRef.current = null;
  };

  const loadMeetings = (filters) => {
    const withSpinner =
      !meetingsRef.current || meetingsRef.current.length === 0;

    if (withSpinner) {
      setMeetingListSpinner(true);
    }

    getMeetings(
      filters,
      (response) => {
        if (withSpinner) {
          setMeetingListSpinner(false);
        }
      },
      (error) => {
        if (withSpinner) {
          setMeetingListSpinner(false);
        }
        setLoading(false);
      }
    );
  };

  const loadMeetingsHistory = ({ before, dateFrom, dateTo, q, reset } = {}) => {
    const withSpinner = reset && (!pastMeetings || pastMeetings.length === 0);

    if (withSpinner) {
      setMeetingListSpinner(true);
    }

    getMeetingsHistory(
      { before, dateFrom, dateTo, q, reset },
      (response) => {
        if (withSpinner) {
          setMeetingListSpinner(false);
        }
      },
      (error) => {
        if (withSpinner) {
          setMeetingListSpinner(false);
        }
        setLoading(false);
      }
    );
  };

  const loadConferences = useCallback(() => {
    const withSpinner =
      !conferencesRef.current || conferencesRef.current.length === 0;

    if (withSpinner) {
      setMeetingListSpinner(true);
    }

    getConferences(
      () => {
        if (withSpinner) {
          setMeetingListSpinner(false);
        }
      },
      () => {
        if (withSpinner) {
          setMeetingListSpinner(false);
        }
        setLoading(false);
      }
    );
  }, [getConferences]);

  const handleCloseMeetingDetails = () => {
    setIsMeetingDetailsOpen(false);
    setSelectedMeeting(null);
  };

  const handleCloseConferenceDetails = () => {
    setIsMeetingDetailsOpen(false);
    setSelectedConference(null);
  };

  const handleSelectMeeting = (meeting) => {
    setSelectedMeeting(meeting);
    setSelectedConversation(null);
    setIsMeetingDetailsOpen(true);
    setIsAddNewMeetingOpen(false);
  };

  const handleSelectConference = (conference) => {
    setSelectedConference(conference);
    setSelectedConversation(null);
    setIsMeetingDetailsOpen(true);
    setIsAddNewMeetingOpen(false);
  };

  const handleDeleteMeeting = (meetingId, onDeleted = loadMeetings) => {
    setLoading(true);
    deleteMeeting(
      meetingId,
      (response) => {
        setLoading(false);
        onDeleted();
      },
      (error) => {
        setLoading(false);
        notifyError(getApiErrorMessage(error, t, {
          errorCodeMap: {
            [ERROR_MEETING_ROOM_DELETE_BLOCKED]: 'meetings.delete_series_room_blocked',
          },
          validationMessageMap: {
            'not authorized to delete this meeting': 'meetings.delete_not_authorized',
            'do not have access to this meeting': 'meetings.no_access_error',
          },
        }));
      }
    );
  };

  const handleDeleteMeetingBtn = (meeting, onDeleted) => {
    handleDeleteMeeting(meeting.id, onDeleted);
    setIsMeetingDetailsOpen(false);
    setSelectedMeeting(null);
  };

  const handleDeleteConference = (conferenceId) => {
    setLoading(true);
    deleteConference(
      conferenceId,
      () => {
        setLoading(false);
        loadConferences();
        notifySuccess(t('conferences.deleted_success'));
      },
      () => {
        setLoading(false);
        notifyError(t('general.something_wrong'));
      }
    );
  };

  const handleDeleteConferenceBtn = (conference) => {
    handleDeleteConference(conference.id);
    setIsMeetingDetailsOpen(false);
    setSelectedConference(null);
  };

  const handleUpdateMeetingDetails = (
    id,
    title,
    description,
    participants,
    otherParticipants,
    startAt,
    endAt
  ) => {
    const participantsIds = participants.map((item) => {
      return item.id;
    });

    const objectData = {
      id: id,
      title: title,
      description: description,
      start_at: startAt.toISOString(),
      end_at: endAt.toISOString(),
      participants_ids: participantsIds,
      other_participants: otherParticipants,
    };

    if (objectData.title.length < 3){
      notifyError(t('meetings.title_too_short'));
      return;
    }

    if (objectData.participants_ids.length == 0 && objectData.other_participants.length == 0) {
      notifyError(t('meetings.insufficient_participants'));
      return;
    }

    updateMeeting(
      objectData,
      (response) => {
        const meetingResponse = response.data.meeting;
        setSelectedMeeting(meetingResponse);
        setIsMeetingDetailsOpen(false);
        loadMeetings();
      },
      (error) => {
        notifyError(getApiErrorMessage(error, t, {
          errorCodeMap: {
            ACCESS1005: 'meetings.plan_or_users_error',
          },
          validationMessageMap: {
            "Title can't be blank": 'general.error_title_required',
            'must be after the start time': 'general.error_end_before_start',
            'do not exist': 'general.error_invalid_participants',
            'not authorized to edit this meeting': 'meetings.edit_not_authorized_error',
            'do not have access to this meeting': 'meetings.no_access_error',
          },
        }));
      }
    );
  };

  const handleRegeneratePasscode = (meetingId) => {
    regeneratePasscode(
      meetingId,
      (response) => {
        setSelectedMeeting(response.data.meeting);
        notifySuccess(t('meetings.passcode_regenerated'));
      },
      (error) => {
        notifyError(getApiErrorMessage(error, t, {
          validationMessageMap: {
            'not authorized to edit this meeting': 'meetings.edit_not_authorized_error',
            'This meeting has ended': 'meetings.meeting_has_ended',
            'The passcode can only be changed before the meeting starts': 'meetings.regenerate_passcode_disabled',
          },
        }));
      }
    );
  };

  const handleUpdateConferenceDetails = (
    id,
    title,
    description,
    termsAndConditions,
    organizers,
    presenters,
    otherParticipants,
    startAt,
    endAt,
    settings,
    headerImageFile = null,
    headerImageRemoved = false
  ) => {
    const organizerIds = organizers.map((item) => item.id);
    const presenterIds = presenters.map((item) => item.id);

    const objectData = {
      id: id,
      title: title,
      description: description,
      terms_and_conditions: termsAndConditions,
      start_at: startAt.toISOString(),
      end_at: endAt.toISOString(),
      organizer_ids: organizerIds,
      participants_ids: presenterIds,
      other_participants: otherParticipants,
      allow_mic: settings.allow_mic,
      allow_camera: settings.allow_camera,
      allow_chat: settings.allow_chat,
      allow_polls: settings.allow_polls,
      auto_approve_participants: settings.auto_approve_participants,
      invite_all_org_users: settings.invite_all_org_users,
      public_registration: settings.public_registration,
    };

    const normalizeOtherParticipantsEmails = (participants) =>
      (participants || [])
        .map((participant) => {
          if (typeof participant === "string") return participant.trim();
          return participant?.email || participant?.name || "";
        })
        .filter(Boolean);

    const buildUpdateConferencePayload = () => {
      if (!headerImageFile && !headerImageRemoved) return objectData;

      const formData = new FormData();
      formData.append("id", objectData.id);
      formData.append("title", objectData.title);
      formData.append("description", objectData.description || "");
      formData.append("terms_and_conditions", objectData.terms_and_conditions || "");
      formData.append("start_at", objectData.start_at);
      formData.append("end_at", objectData.end_at);

      (objectData.organizer_ids || []).forEach((orgId) =>
        formData.append("organizer_ids[]", orgId)
      );
      (objectData.participants_ids || []).forEach((participantId) =>
        formData.append("participants_ids[]", participantId)
      );

      normalizeOtherParticipantsEmails(objectData.other_participants).forEach(
        (email) => {
          formData.append("other_participants[]", email);
        }
      );

      formData.append("allow_mic", String(objectData.allow_mic));
      formData.append("allow_camera", String(objectData.allow_camera));
      formData.append("allow_chat", String(objectData.allow_chat));
      formData.append("allow_polls", String(objectData.allow_polls));
      formData.append("auto_approve_participants", String(objectData.auto_approve_participants));
      formData.append("invite_all_org_users", String(objectData.invite_all_org_users));
      formData.append("public_registration", String(objectData.public_registration));

      if (headerImageFile) {
        formData.append("header_image", headerImageFile);
      } else if (headerImageRemoved) {
        // Send a blank value to trigger server-side purge logic.
        formData.append("header_image", "");
      }
      return formData;
    };

    if (objectData.title.length < 3) {
      notifyError(t('conferences.title_too_short'));
      return;
    }

    if (objectData.organizer_ids.length === 0) {
      notifyError(t('conferences.insufficient_participants'));
      return;
    }

    updateConference(
      buildUpdateConferencePayload(),
      (response) => {
        const conferenceResponse = response.data.conference;
        setSelectedConference(conferenceResponse);
        setIsMeetingDetailsOpen(false);
        loadConferences();
        notifySuccess(t('conferences.updated_success'));
      },
      () => {
        notifyError(t('general.something_wrong'));
      }
    );
  };

  const processQueue = async () => {
    if (isUpdateMessageProcessing || updateMessagesQueue.length === 0) return;

    isUpdateMessageProcessing = true;

    while (updateMessagesQueue.length > 0) {
      const task = updateMessagesQueue.shift();
      task(); // Wait for task to complete
    }

    isUpdateMessageProcessing = false;
  };

  const enqueueUpdate = (fn) => {
    updateMessagesQueue.push(fn);
    processQueue();
  };

  useEffect(() => {
    loadConversations();
    loadCalls();
    loadMeetings();
    loadContacts();
    checkSubscriptions();
    add_observer(MessagesChannelObserver);
    add_observer(ConversationsChannelObserver);

    if (isElectron) {
      add_observer(ElectronNotificationsChannelObserver);
    }
    handleLinksquaredDeepLink();

    return () => {
      remove_observer(MessagesChannelObserver);
      remove_observer(ConversationsChannelObserver);

      if (isElectron) {
        remove_observer(ElectronNotificationsChannelObserver);
      }
    };
  }, []);

  useEffect(() => {
    loadConferences();
  }, []);

  useEffect(() => {
    if (!selectedConversation || selectedConversation.uuid) {
      return;
    }
    loadMessageForConversation(selectedConversation, 1);
  }, [selectedConversation]);

  useEffect(() => {
    if (currentConversationMessages.length !== 0) {
      setLastMessage(currentConversationMessages);
    }

    if (!currentMessagesRef.current) {
      return;
    }
    // markMessagesRead(currentMessagesRef.current);
    initializeConversationMood(currentMessagesRef.current);
  }, [currentConversationMessages]);

  useEffect(() => {
    if (
      parseInt(LocalStorage.getRatingCounter()) % 1000 === 0 &&
      selectedConversation
    ) {
      setShowRatingCard(true);
    }
  }, [parseInt(LocalStorage.getRatingCounter())]);

  useEffect(() => {
    if (isMobile) {
      navigate("/");
    }
  }, []);

  useEffect(() => {
    if (searchParams.get("from_stripe")) {
      setSearchParams((prev) => {
        prev.delete("from_stripe");
        return prev;
      });
    }

    if (searchParams.get("calcel_from_stripe")) {
      setSearchParams((prev) => {
        prev.delete("calcel_from_stripe");
        return prev;
      });
    }

    if (!("Notification" in window)) {
      return;
    }

    if (Notification.permission === "default" && !cookies.notificationsModal) {
      setShowRequestNotificationModal(true);
    }

    if (searchParams.get("desktop_login") != "true" && !isElectron) {
      fetchPushTokenIfPossible();
    }

    const pendingTool = sessionStorage.getItem("pendingTool");
    if (pendingTool) {
      sessionStorage.removeItem("pendingTool");
      setToggle(TOOLS);
      if (pendingTool === "presentations") {
        setInitialToolCategory(TOOLS_PRESENTATIONS);
      } else if (pendingTool === "video_translation") {
        setInitialToolCategory(TOOLS_VIDEO_TRANSLATION);
      }
    }
  }, []);

  useEffect(() => {
    if (isElectron) {
      if (
        window.electron &&
        typeof window.electron.responseFromSubscribeWindow === "function"
      ) {
        window.electron.responseFromSubscribeWindow(handleResponseFromStripe);
        return () => {
          window.electron.responseFromSubscribeWindow(() => { });
        };
      } else {
        console.err("Electron API not available");
      }
    }
  }, []);

  useEffect(() => {
    generateInviteLink();

    // Close secondary window if arriving at this page
    closeAllSecondaryWindows();
  }, []);

  useEffect(() => {
    if (selectedCall) {
      setIsSubscriptionModalOpen(false);
    }
  }, [selectedCall]);

  useEffect(() => {
    hideDetailsViews();
  }, [toggle]);

  useEffect(() => {
    if (selectedConversation && !isCallInProgress && !showEditMessageModal) {
    const replyState = getReplyState(selectedConversation.id);
    if (replyState && !showReplyMessageModal) {
      setShowReplyMessageModal(true);
      setSelectedMessageForContextMenu({
        messageId: replyState.messageId,
        conversationId: selectedConversation.id,
        messageObject: replyState.messageObject,
      });
      setMessageInput(replyState.replyText || "");
    } else if (!showReplyMessageModal) {
      const draftMessage = getDraftMessage(selectedConversation.id);
      if (draftMessage && messageInput !== draftMessage) {
        setMessageInput(draftMessage);
      }
    }
  }
  }, [isCallInProgress]);
    
  return (
    <FirstWrapper>
      {showRequestNotificationModal && (
        <RequestNotificationsModal
          handleRequestNotificationsPermission={
            handleRequestNotificationsPermission
          }
          handleClose={handleCloseRequestNotificationModal}
        />
      )}

      {isLinksquaredMessageModalOpen && (
        <LinksquaredMessageModal
          setLoading={setLoading}
          loading={loading}
          handleClose={handleCloseLinksuaredMessages}
          handleItemClick={handleLinksquaredMessageClick}
        />
      )}


      {isFullScreenMessageDisplay && (
        <DisplayFullScreenMessage
          handleClose={handleCloseFullScreenMessageDisplay}
          message={fullScreenMessageRef.current}
        />
      )}

      <Container>
        <SideBar
          toggle={toggle}
          setToggle={(option) => {
            setIsMeetingDetailsOpen(false);
            setSelectedMeeting(null);
            setSelectedConference(null);
            setToggle(option);
          }}
          handleOpenLinksuaredMessages={handleOpenLinksuaredMessages}
        />

        {(toggle === SETTINGS || toggle === PROFILE) && <SettingsMenu />}
        {toggle === CHATS && (
          <ChatWrapper
            conversations={conversations}
            selectedConversation={selectedConversation}
            handleSelectConversation={handleSelectConversation}
            loadConversations={loadConversations}
            handleOpenSubscriptionModal={handleOpenSubscriptionModal}
            shouldScrollBottom={shouldScrollBottom}
            inputValue={messageInput}
            handleInputChange={handleMessageInputChange}
            handleSendButton={handleSendButton}
            messages={currentConversationMessages}
            handleReactToMessage={handleReactToMessage}
            handleRemoveOwnMessageReaction={handleRemoveOwnMessageReaction}
            handleShowFullScreenImg={handleShowFullScreenImg}
            handleDeleteMessage={handleDeleteMessage}
            displayRightClickMenu={displayRightClickMenu}
            mediaInputFileRef={mediaInputFileRef}
            fileInputRef={fileInputRef}
            scrollHeightRef={scrollHeightRef}
            setMediaInput={setMediaInput}
            setFileInput={setFileInput}
            mediaInput={mediaInput}
            showEditMessageModal={showEditMessageModal}
            selectedMessageForContextMenu={selectedMessageForContextMenu}
            handleCloseEdit={handleCloseEdit}
            messageInputRef={messageInputRef}
            showReplyMessageModal={showReplyMessageModal}
            handleCloseReply={handleCloseReplyMessageOption}
            fileInput={fileInput}
            shouldLoadMoreMessages={shouldLoadMoreMessages}
            handleGetMoreMessages={handleGetMoreMessages}
            showBlockedChatModal={showBlockedChatModal}
            setShowBlockedChatModal={setShowBlockedChatModal}
            handleUnblockContact={handleUnblockContact}
            messageMood={messageMood}
            setMessageMood={setMessageMood}
            handleShowConversationDetailsMenu={
              handleShowConversationDetailsMenu
            }
            handleCreateCallHeaderClick={handleCreateCallHeaderClick}
            contacts={contacts}
            handleInviteContact={handleInviteContact}
            loadContacts={loadContacts}
            handleBlockContact={handleBlockContact}
            handleShowGroupChatDetails={handleShowGroupChatDetails}
          />
        )}

        {isBlockUsersOpen && (
          <BlockUsers
            handleClose={handleCloseBlockUsers}
            setLoading={setLoading}
            handleBlockContact={handleBlockContact}
            handleUnblockContact={handleUnblockContact}
          />
        )}

        {isQcModalOpen && (
          <QcModal
            qcLink={qcLinkRef.current}
            setIsQcModalOpen={setIsQcModalOpen}
            handleShareBtn={handleShareQcLink}
          />
        )}

        {mediaInput && (
          <SendMedia
            mediaInput={mediaInput}
            setMediaInput={setMediaInput}
            handleSendMedia={handleSendMediaButton}
            selectedConversation={selectedConversation}
            mediaInputFileRef={mediaInputFileRef}
            inputValue={messageInput}
            messageInputRef={messageInputRef}
            handleInputChange={handleMessageInputChange}
          />
        )}

        {fileInput && (
          <SendFile
            fileInput={fileInput}
            setFileInput={setFileInput}
            handleSendFileButton={handleSendFileButton}
            selectedConversation={selectedConversation}
            fileInputRef={fileInputRef}
            inputValue={messageInput}
            messageInputRef={messageInputRef}
            handleInputChange={handleMessageInputChange}
          />
        )}

        {showMessageDetailsModal && (
          <ChatDetailsWrapper>
            <ChatDetailsHeader
              selectedConversation={selectedConversation}
              handleClose={() => handleShowMessageInfoModal()}
            />
            <MessageDetailsModal
              selectedMessage={selectedMessageForContextMenu}
              selectedConversation={selectedConversation}
            />
          </ChatDetailsWrapper>
        )}

        {showQuickChatDetails && selectedConversation.open && (
          <ChatDetailsWrapper>
            <ChatDetailsHeader
              selectedConversation={selectedConversation}
              handleClose={() => handleShowQcChatDetails()}
            />
            <QcChatDetailsView
              conversationData={selectedConversation}
              handleShareBtn={handleShareQcLink}
              handleCloseChatBtn={handleCloseChatBtn}
            />
          </ChatDetailsWrapper>
        )}

        {showFullScreenImg && (
          <FullscreenImage
            selectedConversation={selectedConversation}
            handleDeletePhoto={handleDeletePhoto}
            image={fullScreenImg.image}
            conversationId={fullScreenImg.conversationId}
            messageId={fullScreenImg.messageId}
            handleCloseFullScreenImg={handleCloseFullScreenImg}
          />
        )}

        {toggle === CALLS && (
          <CallWrapper
            calls={calls}
            selectedCall={selectedCall}
            handleSelectCall={handleSelectCall}
            handleCreateCallOnContactClick={handleCreateCallOnContactClick}
            loadCalls={loadCalls}
            setLoading={setLoading}
            contacts={contacts}
            handleInviteContact={handleInviteContact}
          />
        )}

        {toggle === TOOLS && !isMeetingOverlayActive && (
          <ToolsMenu
            translationHistory={translationHistory}
            setTranslationHistory={setTranslationHistory}
            setLoading={setLoading}
            fromLanguage={fromLanguage}
            setFromLanguage={setFromLanguage}
            toLanguage={toLanguage}
            setToLanguage={setToLanguage}
            from={from}
            setFrom={setFrom}
            initialCategory={initialToolCategory}
          />
        )}
        {toggle === CONTACTS && (
          <Contacts
            contacts={contacts}
            loadContacts={loadContacts}
            inviteAction={handleInviteContact}
            callAction={handleCreateCallOnContactClick}
            chatAction={handleStartNewChat}
            blockAction={handleBlockContact}
            unblockAction={handleUnblockContact}
          />
        )}

        {toggle === MEETINGS && (
          <Meetings
            selectedMeeting={selectedMeeting}
            meetings={meetings}
            pastMeetings={pastMeetings}
            pastMeetingsHasMore={pastMeetingsHasMore}
            loadMeetingsHistory={loadMeetingsHistory}
            handleJoinMeeting={handleJoinMeeting}
            handleSelectMeeting={handleSelectMeeting}
            loadMeetings={loadMeetings}
            handleCloseMeetingDetails={handleCloseMeetingDetails}
            handleDeleteMeetingBtn={handleDeleteMeetingBtn}
            handleUpdateMeetingDetails={handleUpdateMeetingDetails}
            handleRegeneratePasscode={handleRegeneratePasscode}
            contacts={contacts}
            checkSubscriptionAndExecute={checkSubscriptionAndExecute}
          />
        )}
        {toggle === CONFERENCES && (
          <Conferences
            selectedConference={selectedConference}
            conferences={conferences}
            handleJoinConference={handleJoinConference}
            handleSelectConference={handleSelectConference}
            loadConferences={loadConferences}
            handleCloseConferenceDetails={handleCloseConferenceDetails}
            handleDeleteConferenceBtn={handleDeleteConferenceBtn}
            handleUpdateConferenceDetails={handleUpdateConferenceDetails}
            contacts={contacts}
          />
        )}

        {showForwardModal && (
          <ForwardModal
            handleClose={handleCloseForwardModal}
            chats={conversations.filter((conv) => !conv.with_emotii)}
            contextMenuItem={selectedMessageForContextMenu}
          />
        )}

        {isSubscriptionModalOpen && (
          <SubscriptionModal
            handleClose={handleCloseSubscriptionModal}
            handleSubscribeClick={handleSubscribeClick}
            handleUnSubscribeClick={handleUnSubscribeClick}
            handleSetInvitations={handleSetInvitationsSubscribeModal}
          />
        )}

        {isReferralMdalOpen && (
          <RefferalModal
            setLoading={setLoading}
            handleClose={handleCloseReferralModal}
          />
        )}

        {((!selectedConversation?.with_emotii &&
          selectedConversation?.quick_chat &&
          selectedConversation?.open) ||
          (!selectedConversation?.with_emotii &&
            !selectedConversation?.quick_chat)) &&
          !isSimpleAndBlockedConversation(selectedConversation) && (
            <RightClickMenu
              handleDeleteMessage={handleDeleteMessage}
              handleReportMessage={handleReportMessage}
              handleForwardMessage={handleForwardMessage}
              handleEditMessageOption={handleEditMessageOption}
              handleReplyMessageOption={handleReplyMessageOption}
              handleCopyOption={handleCopyOption}
              contextMenuItem={selectedMessageForContextMenu}
              setShowForwardModal={setShowForwardModal}
              selectedConversation={selectedConversation}
              user={user}
              conversations={conversations}
              currentConversationMessages={currentConversationMessages}
              handleInfoOption={handleOpenMessageInfoModal}
              menuId={MENU_ID}
            />
          )}

          {showEditCancelConfirmation && (
            <DeleteConfirmationChild
              setOpen={setShowEditCancelConfirmation}
              open={showEditCancelConfirmation}
              action={handleConfirmCancelEdit}
              variant="cancel_edit"
            />
          )}
      </Container>
      {showRatingCard && (
        <RatingModal
          showRatingCard={showRatingCard}
          setShowRatingCard={setShowRatingCard}
          sendRating={handleSendRating}
        />
      )}
    </FirstWrapper>
  );
};

export default ChatPage;
const FirstWrapper = styled.div`
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  padding: 0px;
  overflow: hidden;
  position: relative;
  isolation: isolate;
  @media (max-width: 1440px) {
    margin: 0;
  }
`;
const Container = styled.div`
  display: flex;
  min-width: 600px;
  overflow: hidden;
  height: 100%;
  width: 100%;
  position: relative;
`;

const ChatDetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 350px;
  position: relative;
  border-left: 1px solid ${({ theme }) => theme.sidebar.borderColor};
`;
